export { default as enGB } from './en-GB';
export { default as enUS } from './en-US';
export { default as faIR } from './fa-IR';
